import {useEffect, useRef} from 'react';

export interface BulletinListFilters {
    user_id?: number | null;
    client_id?: number | null;
    start_date?: string | null;
    end_date?: string | null;
    bulletin_status_ids?: string[] | null;
    term?: string | null;
}

const extractFilters = (parsedFilters: Record<string, string>): BulletinListFilters => ({
    user_id: parsedFilters['user'] ? parseInt(parsedFilters['user'], 10) : null,
    client_id: parsedFilters['client'] ? parseInt(parsedFilters['client'], 10) : null,
    start_date: parsedFilters['date__from']?.substring(0, 10) || null,
    end_date: parsedFilters['date__to']?.substring(0, 10) || null,
    bulletin_status_ids: parsedFilters['bulletinStatus'] ? [parsedFilters['bulletinStatus']] : null,
    term: parsedFilters['term'] || null,
});

export const useBulletinListFilters = () => {
    const bulletinListFiltersRef = useRef<BulletinListFilters>({});

    useEffect(() => {
        const originalFetch = window.fetch;

        window.fetch = function (input: RequestInfo | URL, init?: RequestInit) {
            const url = typeof input === 'string' ? input : input instanceof URL ? input.toString() : input.url;
            if (url.includes('bulletin/list/extended') && init?.body) {
                try {
                    const parsed = typeof init.body === 'string' ? JSON.parse(init.body) : null;
                    if (parsed?.filters) {
                        bulletinListFiltersRef.current = extractFilters(parsed.filters);
                    }
                } catch (_) {}
            }
            return originalFetch.apply(this, [input, init] as any);
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return bulletinListFiltersRef;
};
